import * as Schema from 'owa-graph-schema';
import { EntityType } from '@office-start/nova-facade-types';

/**
 * Transforms an AppDefinition object into a M365PlatformApplication object
 * @param appDefinition
 * @returns
 */
export function convertAppDefinitionToM365PlatformApplication(
    appDefinition: Schema.AppDefinition,
    entityType: EntityType
): Schema.M365PlatformApplication {
    return {
        __typename: 'M365PlatformApplication',
        accessibleName: appDefinition.name,
        name: appDefinition.name,
        badge: {
            __typename: 'M365ApplicationNumericBadge',
            count: 0,
            countDescription: 'Empty',
        },
        brandingColor: '#0078d4',
        canLaunchOut: entityType === EntityType.m365_app,
        id: appDefinition.id,
        icon: {
            __typename: 'RemoteImage',
            src: appDefinition.largeImageUrl,
        },
        command: {
            entity: {
                entityId: appDefinition.id,
                type: entityType,
                action: 'default',
            },
            command: {
                visibilityState: 'show',
                stateTransition: 'flush',
            },
        },
        isInUse: false,
        isPinnable: false,
        // TODO: Remove this
        // lockedIndex: null,
        lockedIndex: appDefinition.name.toLowerCase().indexOf('test') >= 0 ? 15 : null,
        pinnedIndex: null,
        selectedStateIconOverride: {
            __typename: 'RemoteImage',
            src: appDefinition.largeImageUrl,
        },
    };
}
